import {useQuery} from "@tanstack/react-query";
import {Database, ServerCog, TimerReset} from "lucide-react";
import {EndpointReadinessGrid} from "../../shared/components/BusinessBlocks";
import {DataState} from "../../shared/components/DataState";
import {loadOptionalEndpoints} from "../control/api";
import {useTranslation} from "../../shared/i18n";


export const SystemPage = () => {
    const {t} = useTranslation();
    const systemQuery = useQuery({
        queryKey: ["admin-system"],
        queryFn: () =>
            loadOptionalEndpoints([
                {key: "migration", url: "/api/v2/admin/system/migration-readiness"},
                {key: "jobs", url: "/api/v2/admin/system/jobs"},
                {key: "ledger", url: "/api/v2/admin/dashboard/ledger-health"},
                {key: "providers", url: "/api/v2/admin/dashboard/provider-health"},
            ]),
        retry: 1,
    });
    const data = systemQuery.data || {};

    return (
        <div className="admin-page">
            <header className="admin-page-header">
                <div>
                    <h1 className="admin-page-title">System health</h1>
                    <p className="admin-page-copy">
                        {t("sections.system.p1")}
                    </p>
                </div>
                <div className="admin-pill"><ServerCog size={14} /> Yandex-ready</div>
            </header>
            <section className="admin-grid cols-4">
                <article className="admin-card"><p className="admin-card-title"><Database size={14} /> {t("sections.system.p2")}</p><p className="admin-card-value">{data.migration?.ok ? "OK" : "—"}</p></article>
                <article className="admin-card"><p className="admin-card-title"><TimerReset size={14} /> Jobs</p><p className="admin-card-value">{data.jobs?.ok ? "OK" : "—"}</p></article>
                <article className="admin-card"><p className="admin-card-title">Ledger</p><p className="admin-card-value">{data.ledger?.ok ? "OK" : "—"}</p></article>
                <article className="admin-card"><p className="admin-card-title">{t("sections.system.p3")}</p><p className="admin-card-value">{data.providers?.ok ? "OK" : "—"}</p></article>
            </section>
            <article className="admin-card">
                <p className="admin-card-title">Endpoint readiness</p>
                <EndpointReadinessGrid data={data} />
            </article>
            <DataState
                title="Backend readiness"
                copy={t("sections.system.p4")}
            />
        </div>
    );
};
